<template>
  <div class="q-pt-md">

    <div class="row q-px-sm">
      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Plan</div>
        <div class="product-value text-center">{{ (plan == 'CS' ? 'CASH' : plan) }}</div>
      </div>

      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Current NAV <code>({{ asOffDate }})</code></div>
        <div class="product-value text-center">{{ parseFloat(holding.nav).toFixed(4) }}</div>
      </div>

      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Balance Units</div>
        <div class="product-value text-center">{{ holding.units | thousandSeparator }}</div>
      </div>

      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Pending Redemption / Switch Out</div>
        <div class="product-value text-center">{{ pendingRedemption | thousandSeparator }}</div>
      </div>

      <!-- <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Pending Investment / Switch In</div>
        <div class="product-value text-center">{{ pendingInvestment | thousandSeparator }}</div>
      </div> -->

      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Available Units</div>
        <div class="product-value text-center" v-bind:class="{ 'text-negative': availableUnits < 0 }">{{ availableUnits | thousandSeparator }}</div>
      </div>

      <div class="col-xs-12 col-sm-2 col-md-2">
        <div class="product-key text-center text-caption text-bold bg-grey-3">Current Market Value ({{ currency }})</div>
        <div class="product-value text-center">{{ holding.amount | thousandSeparator }}</div>
      </div>
    </div>

    <redeem-action
      v-if="this.schemeDetail.length !== 0"
      ref="action"
      :appId=appId
      :customerId=customerId
      :accountId=accountId
      :userId=userId
      :channel=channel
      :scheme=scheme
      :fundName=fundName
      :plan=plan
      :currency=currency
      :actionRules=actionRules
      :isSelf=isSelf
      :env="env"
      :apiUrl="apiUrl"
      :notificationAPIToken="notificationAPIToken"
      :onelookAPIToken="onelookAPIToken"
      :cifAPIToken="cifAPIToken"
      :onboardingAPIToken="onboardingAPIToken"
      :transactionAPIToken="transactionAPIToken"
      :agentEmail="agentEmail"
      :fundAPIToken="fundAPIToken"
    />

  </div>
</template>

<script>
import RedeemAction from './RedeemAction.vue'
import { QInput } from 'quasar'
import axios from 'axios'
import mixins from './mixin'

export default {

  name: 'FundDetailsUtf',

  mixins: [mixins],

  components: {
    RedeemAction,
    QInput
  },

  props: {
    appId: String,
    customerId: String,
    accountId: String,
    userId: String,
    channel: String,
    fundName: String,
    currency: String,
    holding: Object,
    plan: String,
    scheme: String,
    isSelf: { type: Boolean, required: false, default: false },

    env: { type: String, required: false, default: 'development' },
    apiUrl: { type: String, required: false },
    notificationAPIToken: { type: String, required: false },
    onelookAPIToken: { type: String, required: true },
    cifAPIToken: { type: String, required: true },
    onboardingAPIToken: { type: String, required: true },
    transactionAPIToken: { type: String, required: true },
    fundAPIToken: { type: String, required: true },

    agentEmail: { type: String, required: true }
  },

  data() {
    return {
      schemeDetail: [],
      cart: [],
      redeemedUnits: 0,
      switchedUnits: 0,
    }
  },

  computed: {
    
    pendingRedemption() {
      return this.holding.floatingUnitsOut + this.holding.submittedUnitsOut + this.redeemedUnits + this.switchedUnits
    },

    pendingInvestment() {
      return this.holding.floatingUnitsIn - this.holding.submittedUnitsIn
    },

    availableUnits() {
      return this.holding.units - this.pendingRedemption
    },

    actionRules() {
      let rules = {
        maxRedemption: this.availableUnits >= 0 ? this.availableUnits : 0,
        minRedemption: (this.schemeDetail.MinimumRepurchaseUnits ? this.schemeDetail.MinimumRepurchaseUnits : 0),
        minUnitBalance: (this.schemeDetail.MinimumHoldingsOfUnits ? this.schemeDetail.MinimumHoldingsOfUnits : 0),
        nav: this.holding.nav
      }
      return rules;
    },

    asOffDate() {
      return this.holding.asOfDate
    }

  },

  async mounted() {

    // Transaction API : Fetch cart
    await axios({
      method: 'GET',
      url: this.apiUrl + '/transaction/application/' + this.appId,
      headers: {
        Authorization: 'Bearer ' + this.transactionAPIToken
      }
    })
    .then(resp => {
      if (resp.data.TransactionCart) {
        this.$set(this, 'cart', resp.data.TransactionCart)

        if (this.cart.Redemption) {
          const redeemedUnits = this.cart.Redemption.filter(v => {
            return v.Scheme === this.scheme && v.Plan === this.plan && v.SchemeCurrency === this.currency
          }).reduce((total, item) => total = total + item.Units, 0)

          this.$set(this, 'redeemedUnits', redeemedUnits)
        }
        
        if (this.cart.Switching) {
          const switchedUnits = this.cart.Switching.filter(v => {
            return v.FromScheme === this.scheme && v.Plan === this.plan && v.ToSchemeCurrency === this.currency
          }).reduce((total, item) => total = total + item.Units, 0)

          this.$set(this, 'switchedUnits', switchedUnits)
        }
      }
    })
    .catch(err => console.log(err))


    // Fund API : Fetch scheme listing
    axios({
      method: 'GET',
      url: this.apiUrl + '/product/scheme/listing',
      headers: {
        Authorization: 'Bearer ' + this.fundAPIToken
      }
    })
    .then(resp => {
      let details = resp.data.Schemes
        .filter(item => item.Scheme === this.scheme)
        .reduce(item => item)

      this.$set(this, 'schemeDetail', details)
      this.$emit('processing', false)
    })
    .catch(err => console.log(err))

  }

};
</script>

<style scope>
.product-key { border: 1px solid #d9dcde; border-bottom: none; min-height: 80px; padding: 5px; }
.product-value { border: 1px solid #d9dcde; font-weight: bold; }

@media only screen and (max-width: 599px) {
  .product-key {
    min-height: unset;
    text-align: left !important;
    padding: 5px;
  }

  .product-value {
    text-align: left !important;
    margin-bottom: 10px;
    padding: 5px;
  }
}
</style>
